// API color names map to semantic roles; categorical hues below preserve their identity in both themes.
const iconColorClasses = {
  primary: 'text-link',
  secondary: 'text-muted-foreground',
  success: 'text-success',
  danger: 'text-destructive',
  warning: 'text-warning',
  white: 'text-white',
  black: 'text-foreground',
  gray: 'text-muted-foreground',
  'gray-light': 'text-muted-foreground',
  'gray-dark': 'text-foreground',
  purple: 'text-[#8145b5] dark:text-[#d19dff]',
  sky: 'text-[#00749e] dark:text-[#75c7f0]',
  lime: 'text-[#5c7c2f] dark:text-[#bde56c]',
  gold: 'text-[#71624b] dark:text-[#cbb99f]',
  tomato: 'text-[#d13415] dark:text-[#ff977d]',
  brown: 'text-[#815e46] dark:text-[#dbb594]',
} as const;

export type IconColor = keyof typeof iconColorClasses;

export function iconColorClass(color: string | null | undefined): string | undefined {
  const classes: Readonly<Record<string, string>> = iconColorClasses;
  return color != null && Object.hasOwn(iconColorClasses, color) ? classes[color] : undefined;
}
